/**
 * Format newsletter content for display
 * Handles HTML content with proper sanitization and responsive images
 */
export const formatNewsletterContent = (content) => {
  if (!content) return '';

  // Step 1: Remove empty paragraphs and whitespace-only elements
  let formattedContent = content
    // Remove paragraphs that are completely empty
    ?.replace(/<p>\s*<\/p>/gi, '')
    // Remove paragraphs with only &nbsp;
    ?.replace(/<p>(&nbsp;|\s)+<\/p>/gi, '')
    // Remove paragraphs with only <br> tags
    ?.replace(/<p>\s*<br\s*\/?>\s*<\/p>/gi, '')
    // Remove paragraphs with only whitespace and <br> combinations
    ?.replace(/<p>(\s|<br\s*\/?>|&nbsp;)+<\/p>/gi, '')
    // Remove standalone <br> tags between paragraphs
    ?.replace(/<\/p>\s*<br\s*\/?>\s*<p>/gi, '</p><p>')
    // Collapse multiple consecutive <br> tags into single one
    ?.replace(/(<br\s*\/?>\s*){2,}/gi, '<br>')
    // Remove leading/trailing <br> inside paragraphs
    ?.replace(/<p>\s*<br\s*\/?>\s*/gi, '<p>')
    ?.replace(/\s*<br\s*\/?>\s*<\/p>/gi, '</p>')
    // Remove empty divs
    ?.replace(/<div>\s*<\/div>/gi, '')
    ?.replace(/<div>(\s|<br\s*\/?>|&nbsp;)+<\/div>/gi, '');

  // Step 2: Ensure images are responsive while preserving existing attributes
  formattedContent = formattedContent?.replace(
    /<img([^>]*)>/gi,
    (match, attributes) => {
      // Preserve data-align and other existing attributes
      const hasDataAlign = attributes?.includes('data-align');
      const hasStyle = attributes?.includes('style=');
      const hasClass = attributes?.includes('class=');
      
      // If image already has formatting attributes, preserve them
      if (hasDataAlign || (hasStyle && hasClass)) {
        // Just ensure max-width is set for responsiveness
        if (!attributes?.includes('max-width') && !attributes?.includes('max-w-')) {
          if (hasStyle) {
            // Add to existing style
            return match?.replace(/style="([^"]*)"/i, 'style="$1; max-width: 100%; height: auto;"');
          } else {
            // Add new style attribute
            return `<img${attributes} style="max-width: 100%; height: auto;">`;
          }
        }
        return match;
      }
      
      // Add responsive styling if missing
      return `<img${attributes} style="max-width: 100%; height: auto;" class="block my-4 rounded-lg">`;
    }
  );

  return formattedContent;
};

export default formatNewsletterContent;
function ensureProperHtmlFormatting(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: ensureProperHtmlFormatting is not implemented yet.', args);
  return null;
}

export { ensureProperHtmlFormatting };